<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="complaintInfoes"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @select="selectHandle"
        @reset="resetHandle">
      <template slot="otherBtn">
        <!--        <el-button type="primary" :disabled="!selection.length" @click="printHandle"> 打印 </el-button>-->
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="登记日期">
            <el-date-picker
                v-model="createTime"
                :picker-options="pickerOptions"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="createTimeChange"/>
          </el-form-item>
          <el-form-item label="编号">
            <el-input v-model.trim="filter.billNo" placeholder="请输入编号" clearable/>
          </el-form-item>
          <el-form-item label="客户名称">
            <el-input v-model.trim="filter.customerName" placeholder="请输入客户名称" clearable/>
          </el-form-item>
          <el-form-item label="标题">
            <el-input v-model.trim="filter.title" placeholder="请输入标题" clearable/>
          </el-form-item>
          <el-form-item label="销售订单号">
            <el-input v-model.trim="filter.salesOrderNo" placeholder="请输入销售订单号" clearable/>
          </el-form-item>
          <el-form-item label="发出单号">
            <el-input v-model.trim="filter.logisticsBillNO" placeholder="请输入发出单号" clearable/>
          </el-form-item>
          <el-form-item label="是否售后">
            <el-select v-model="filter.isAfterSale" clearable placeholder="请选择是否售后">
              <el-option label="全部" value="-1"/>
              <el-option label="是" value="1"/>
              <el-option label="否" value="0"/>
            </el-select>
          </el-form-item>
          <el-form-item label="是否过保">
            <el-select v-model="filter.isExpired" clearable placeholder="请选择是否过保">
              <el-option label="全部" value="-1"/>
              <el-option label="是" value="1"/>
              <el-option label="否" value="0"/>
            </el-select>
          </el-form-item>
          <el-form-item label="退回单号">
            <el-input v-model.trim="filter.returnBillNo" placeholder="请输入退回单号" clearable/>
          </el-form-item>
          <el-form-item label="是否质量调查">
            <el-select v-model="filter.isQualitySurvey" clearable placeholder="请选择是否质量调查">
              <el-option label="全部" value="-1"/>
              <el-option label="是" value="1"/>
              <el-option label="否" value="0"/>
            </el-select>
          </el-form-item>
          <el-form-item label="是否退回">
            <el-select v-model="filter.isSendBack" clearable placeholder="请选择是否退回">
              <el-option label="全部" value="-1"/>
              <el-option label="是" value="1"/>
              <el-option label="否" value="0"/>
            </el-select>
          </el-form-item>
          <el-form-item label="是否售后维修">
            <el-select v-model="filter.isFixAfterDelivery" clearable placeholder="请选择是否售后维修">
              <el-option label="全部" value="-1"/>
              <el-option label="是" value="1"/>
              <el-option label="否" value="0"/>
            </el-select>
          </el-form-item>
        </el-form>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button
            v-if="limits.subAuth"
            type="primary"
            :disabled="scope.row.status !== 0"
            :loading="submitLoading"
            @click="submitHandle(scope.row)">
          提交
        </el-button>
      </template>
    </viewTable>
    <complaint-info-edit ref="complaintInfoEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import ComplaintInfoEdit from "@/views/AfterSaleManage/ComplaintInfo/ComplaintInfoEdit";

  export default {
    name: "ComplaintInfo",
    components: {ComplaintInfoEdit, viewTable},
    data() {
      return {
        limits: {
          addAuth: this.$auth(556),
          editAuth: this.$auth(557),
          delAuth: this.$auth(559),
          subAuth: this.$auth(558),
        },
        submitLoading: false,
        pickerOptions: {
          shortcuts: [{
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          }],
        },
        selection: [],
        createTime: "",
        filter: {
          billNo: "",
          beginCreateTime: "",
          endCreateTime: "",
          factoryNo: "",
          salesmanName: "",
          customerName: "",
          creatorName: "",
          serviceAddress: "",
          contact: "",
          siteMobile: "",
          status: "",
          title: "",
          isAfterSale: "",
          isExpired: "",
          isQualitySurvey: "",
          isSendBack: "",
          isFixAfterDelivery: "",
          returnBillNo: "",
          logisticsBillNO: "",
        },
        columnsProperty: [
          {
            key: "billNo",
            align: "center",
            width: 150,
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$router.push({
                        path: "/ComplaintInfoPreview",
                        query: {
                          billType: 100,
                          billId: params.row.pkid,
                          $tabName: params.row.billNo,
                        },
                      });
                    },
                  },
                },
                params.row.billNo,
              );
            },
          },
          {
            key: "title",
            align: "center",
            width: 120,
          },
          {
            key: "creatorName",
            align: "center",
            width: 120,
          },
          {
            key: "customerName",
            align: "center",
            width: 210,
          },
          {
            key: "contact",
            align: "center",
            width: 120,
          },
          {
            key: "telephone",
            align: "center",
            width: 120,
          },
          {
            key: "createTime",
            align: "center",
            width: 160,
          },
          {
            tooltip: true,
            ellipsis: true,
            key: "deliveryAddress",
            align: "center",
            width: 160,
          },
          {
            key: "note",
            align: "center",
            width: 160,
          },
          {
            key: "logisticsBillNO",
            align: "center",
            width: 160,
          },
          {
            key: "isAfterSale",
            align: "center",
            width: 160,
          },
          {
            key: "returnBillNo",
            align: "center",
            width: 160,
          },
          {
            key: "salesOrderNo",
            align: "center",
            width: 160,
          },
          {
            key: "isQualitySurvey",
            align: "center",
            width: 160,
          },
          {
            key: "isFixAfterDelivery",
            align: "center",
            width: 160,
          },
          {
            key: "isCollectFee",
            align: "center",
            width: 160,
          },
          {
            key: "finalPrice",
            align: "center",
            width: 160,
          },
          {
            key: "isSendBack",
            align: "center",
            width: 160,
          },
          {
            key: "consigneePhone",
            align: "center",
            width: 160,
          },
          {
            key: "consignee",
            align: "center",
            width: 160,
          },
          {
            key: "businessTypeName",
            align: "center",
            width: 160,
          },
          {
            key: "usePhase",
            align: "center",
            width: 160,
          },
          {
            key: "siteEnvironment",
            align: "center",
            width: 160,
          },

          {
            key: "action",
            align: "center",
            width: 200,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      addEditHandle(row) {
        this.$refs.complaintInfoEdit.open(row);
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      submitHandle(row) {
        this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
          this.submitLoading = true;
          this.$http.get("basic", `complaintInfoes/submitOA/${row.pkid}`).then((resp) => {
            if (resp.success) {
              this.$message.success("提交成功");
              this.submitLoading = false;
              this.loadData();
            } else {
              this.submitLoading = false;
            }
          }).catch(() => {
            this.submitLoading = false;
          },
          );
        });
      },
      createTimeChange(date) {
        if (date !== null) {
          this.filter.beginCreateTime = date[0];
          this.filter.endCreateTime = date[1];
        } else {
          this.filter.beginCreateTime = "";
          this.filter.endCreateTime = "";
        }
      },
      deleteHandle(row) {
        this.$http.delete("basic", "complaintInfoes", row.pkid).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
      selectHandle(selection) {
        this.selection = selection;
      },

      resetHandle(filter) {
        this.filter = filter;
      },

      otherAuth(row) {
        return row.status !== 0;
      },
    },
  };
</script>
